import type { SoundDesign } from '../models/sound-design.ts'
import { SoundDesignService } from '../../data/sound-design.service.ts'
import { mapAlgoliaPage } from '../../../shared/domain/mappers/map-algolia-page.ts'
import { mapSoundDesignDtoToSoundDesign } from '../mappers/map-sound-design-dto-to-sound-design.ts'
import type { Paged } from '../../../shared/domain/models/paged.ts'
import type { SoundDesignParameters } from '../models/sound-design-parameters.ts'
import { mapSoundDesignFacetsToSoundDesignFilters } from '../mappers/map-sound-design-facets-to-sound-design-filters.ts'
import type { SoundDesignFilters } from '../models/sound-design-filters.ts'

export const fetchSoundDesigns = async (
  page: number,
  filters: SoundDesignFilters,
  searchTerm?: string
): Promise<Paged<SoundDesign, SoundDesignParameters>> => {
  const PAGE_SIZE = 20
  const res = await SoundDesignService.getSoundDesigns(
    page,
    PAGE_SIZE,
    searchTerm,
    filters
  )
  return mapAlgoliaPage(
    mapSoundDesignDtoToSoundDesign,
    mapSoundDesignFacetsToSoundDesignFilters,
    res
  )
}
